import BasePaths from 'automation-ui-routing/BasePaths';
import { getFlowRoute, getFlowRevisionRoute } from 'automation-ui-routing/utils';
// Get the route to return to from the enrollment panel
export const getBaseCanvasRoute = ({
  flowId,
  params
}) => {
  if (params.revisionId) {
    return `${getFlowRevisionRoute(flowId, params.revisionId)}/${BasePaths.EDIT}`;
  }
  return `${getFlowRoute(flowId)}/${BasePaths.EDIT}`;
};

// Gets the route for the enrollment redesign view
export const getEventEnrollmentRoute = ({
  flowId,
  params
}) => {
  if (params.revisionId) {
    return `${getFlowRevisionRoute(flowId, params.revisionId)}/${params.screen}/${BasePaths.FLOW_CANVAS_ENROLLMENT_CONFIG}`;
  }
  return `${getFlowRoute(flowId)}/${BasePaths.EDIT}/${BasePaths.FLOW_CANVAS_ENROLLMENT_CONFIG}`;
};

// Gets the route for the old list enrollment view
export const getListEnrollmentRoute = ({
  flowId,
  params
}) => {
  if (params.revisionId) {
    return `${getFlowRevisionRoute(flowId, params.revisionId)}/${params.screen}/${BasePaths.PLATFORM_FLOW_CONFIGS}/${BasePaths.PLATFORM_ENROLLMENT}`;
  }
  return `${getFlowRoute(flowId)}/${BasePaths.EDIT}/${BasePaths.PLATFORM_FLOW_CONFIGS}/${BasePaths.PLATFORM_ENROLLMENT}`;
};